export function getPeriod(year: number, month: number) {
    const today = new Date();
    return {
        year: year || today.getFullYear(),
        month: month || today.getMonth() + 1
    };
}